import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["visibleElement"]
  static values = {
    turboLoadUrl: String
  }

  connect() {
    this.loading = false
    this.observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        this._turboRequest()
      }
    })
    this.observer.observe(this.visibleElementTarget)
  }

  disconnect() {
    this.observer.disconnect()
  }

  _turboRequest(){
    if (this.loading) return
    this.loading = true

    fetch(this.turboLoadUrlValue, {
      headers: {
        Accept: "text/vnd.turbo-stream.html",
      },
    })
    .then(response => {
      if (!response.ok) throw new Error(response.statusText)
      return response.text()
    })
    .then(html => Turbo.renderStreamMessage(html))
    .catch(() => {
      this.loading = false
    })
  }

}
